import { useOutletContext } from "react-router-dom";
import { LabelText, LittleSubHeadline, LittleText, MediumText } from "../../../../components/typography";
import { OnboardingBodyBlock } from "../settings";
import { OnboardingButtons } from "../../../../components/ui/button";
import { COLORS } from "../../../../assets/utils/enums/colors";
import styled from "styled-components";
import { structureCRMData, StructureCRMEnum } from "../../../../assets/utils/data/onboarding";
import { boxShadow } from "../../../../components/components-style";

export default function StructureStep() {
    const { structure, setStructure } =
        useOutletContext<{ structure: string; setStructure: React.Dispatch<React.SetStateAction<StructureCRMEnum>> }>();
    return (
        <OnboardingBodyBlock className="align-items-start mt-2">
            <LabelText>Оберіть шаблон для старту</LabelText>
            <span className="pt-2">
                <LittleText>Ми підготували готові налаштування для популярних типів бізнесу.</LittleText>
                <LittleText className="accent-color">Усі налаштування можна змінити в будь-який момент. Для цього перейдіть у Налаштування після завершення створення команди.</LittleText>
            </span>
            <OnboardingBodyItemsBlock>
                {structureCRMData.map((item, index) =>
                    <StructureItem key={index} $active={item.code === structure} $color={item.color}
                        onClick={() => setStructure(item.code as StructureCRMEnum)}>
                        <img src={item.icon} alt={item.title} />
                        <span className="d-flex flex-column gap-1">
                            <LittleSubHeadline>{(index + 1).toString().padStart(2, "0")}.</LittleSubHeadline>
                            <MediumText>{item.title}</MediumText>
                            <LittleText>{item.description}</LittleText>
                        </span>
                    </StructureItem>
                )}
            </OnboardingBodyItemsBlock>
            <OnboardingButtons isBackBtn={true} state={!structure} path="/onboarding/finish" />
        </OnboardingBodyBlock>
    )
}

export const OnboardingBodyItemsBlock = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background-color: ${COLORS.gray};
    border-radius: 8px;
    margin-top: 16px;
    ${boxShadow(COLORS["light-gray"])};
`

const StructureItem = styled.div<{ $color: string; $active: boolean }>`
padding: 24px;
background-color: ${COLORS.white};
border-radius: 12px;
flex: 0 0 33%;
display: flex;
flex-direction: column;
gap: 60px;
border: 3px solid ${({ $active, $color }) => $active ? $color : COLORS.gray}; 
transition: border 0.3s ease; 

&:hover {
border: 3px solid ${({ $color }) => $color};  
cursor: pointer;
${LittleSubHeadline} {
    color: ${({ $color }) => $color};
}
}

img {
    width: 40px;
    height: 40px;
}

${MediumText} {
    border-bottom: 1.5px solid ${COLORS["light-bg-color"]};
    padding-bottom: 8px;
    color: ${COLORS.secondary1};
}
${LittleSubHeadline} {
    color: ${({ $active, $color }) => $active ? $color : COLORS.secondary1};
    transition: color 0.3s ease; 
}
${LittleText} {
    font-weight: 400;
    color: ${COLORS["bg-text-color"]};
}
`